"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WholesaleOrderOrigin = void 0;
exports.WholesaleOrderOrigin = {
    REPLENISHMENT: "REPLENISHMENT",
    WHOLESALE: "WHOLESALE",
};
//# sourceMappingURL=wholesale-order-origin.js.map